import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

export const CoOpCampaignSubType = 10;

export default function get() {
  const isCPGForBSCEnabled = Boolean(_.result(config.get('Permissions'), 'IsCPGForBSCEnabled', false));

  return isCPGForBSCEnabled && _.result(config.get('CurrentCampaign'), 'CampaignSubType') === CoOpCampaignSubType;
}
